import React, { type InputHTMLAttributes } from 'react';

import { Input } from '@pkg/components/Sections/Admin/components/Form';
import { StyledDescription, StyledLabel, Wrapper } from '@pkg/components/Sections/Admin/components/Form/styles';

interface SharedProps {
    label: string;
    name: string;
    description?: string;
    errorMessage?: string;
    children?: React.ReactNode;
    customWidth?: string;
}

type LabelledInputProps = SharedProps & InputHTMLAttributes<HTMLInputElement>;

export const LabelledInput = ({ label, name, description, errorMessage, customWidth, ...rest }: LabelledInputProps) => {
    return (
        <Wrapper $width={customWidth}>
            <StyledLabel htmlFor={name}>
                {label}
                {rest.required ? `*` : ''}
            </StyledLabel>
            {errorMessage && <StyledDescription $isError>{errorMessage}</StyledDescription>}
            <Input name={name} {...rest} />
            {description && <StyledDescription>{description}</StyledDescription>}
        </Wrapper>
    );
};
